var exports = {
  "k": "xf61da738--3178b2--container",
};

module.exports = exports;
